import { makeStyles } from 'tss-react/mui';

export const useRequestsChartStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(7.5),

    height: '100%',
    padding: theme.spacing(7.5),

    borderRadius: theme.shape.borderRadius,

    background: theme.palette.background.paper,

    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(5),

      padding: theme.spacing(5),
    },
  },
  content: {
    position: 'relative',
    overflow: 'hidden',

    height: '100%',
  },
}));
